export default "__VITE_ASSET__CH6TtTcB__"